import React, { useEffect, useRef, useState } from 'react';
import {
	Alert,
	Box,
	CircularProgress,
	Collapse,
	Divider,
	IconButton,
	Snackbar,
	Typography,
} from '@mui/material';
import CustomButton from '@src/components/CustomButton/CustomButton';
import {
	CommentIcon2,
	DecQuantityIcon,
	DeleteIcon,
	EditIcon,
	IncQuantityIcon,
	LockIcon,
} from '@src/components/Icons';
import PageHeader from '@src/components/PageHeader/PageHeader';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import CustomDatePicker from '@src/components/CustomDatePicker/CustomDatePicker';
import LabeledTextField from '@src/components/CustomTextField/LabeledTextField';
import SearchBar from '@src/components/SearchBar';
import CustomModal from '@src/components/CustomModal';
import CustomDataGrid2 from '@src/components/CustomDataGrid/CustomDataGrid2';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { AxiosError, AxiosResponse } from 'axios';
import OrderbookProducts from './orderbookProducts';
import CustomAlert from '@src/components/CustomAlert/CustomAlert';
import { CustomAlertType } from '../Catalogs';
import moment from 'moment';
import ProductDetails from '@src/components/ProductDetails/ProductDetails';
import ConfirmModal from '@src/components/ConfirmModal/ConfirmModal';
import {
	canEditOrder,
	cleanObject,
	convertUTCDateIntoIndianTimezone,
	deepEqual,
	editOrderPermission,
	formatPriceValue,
} from '@src/helpers/Helpers';
import { useAppSelector } from '@src/store/hooks';
import { RESTAURANT } from '@src/Constants';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import CustomPermission from '@src/components/Permissions/CustomPermission';
import Loading from '@src/components/Loading/Loading';
import CustomTooltip from '@src/components/CustomTootip/CustomTooltip';
import { IsMobileWidth } from '@src/components/MediaQueryUtils';
import PageHeaderMobile from '@src/components/PageHeader/PageHeaderMobile';
import ProductCustomCard from '@src/components/CustomCard/ProductCustomCard';
import CustomTextButton from '@src/components/CustomButton/CustomTextButton';
import SlidableDrawer from '@src/components/CustomModal/SlidableDrawer';
import { Category } from '../MarketPlace';
import { SelectedItemsTextContainer } from '@src/components/CommonComponents/Common';
import ProductCard from '@src/components/CustomCard/ProductCard';
import { Filters, Option, Product, TimeoutHandler } from '@src/interfaces/type';
import CustomFilter from '@src/components/CustomFilter/CustomFilter';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: auto;
	padding: 20px;
	gap: 25px;
	overflow: auto;
	@media screen and (max-width: 750px) {
		margin-bottom: 68px;
	}
`;

const FieldsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	#orderNo {
		display: flex;
		justify-content: space-between;
		h3 {
			color: #000;
			font-size: 20px;
			font-weight: 700;
		}
		@media screen and (max-width: 750px) {
			flex-direction: column;
			gap: 14px;
		}
	}
	.fields {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
		color: var(--gray-g-700, #5c5c5c);
		font-family: Nunito Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		color: var(--color-font-grey);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		gap: 5px;

		span {
			font-weight: 700;
		}
	}
`;

const CommentField = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	.fields {
		font-size: 16px;
		color: var(--gray-g-700, #5c5c5c);
		font-family: Nunito Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		color: var(--color-font-grey);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		gap: 5px;

		span {
			font-weight: 700;
		}
	}
`;
const DateFieldsContainer = styled.div`
	display: flex;
	gap: 22px;
	align-items: center;
	flex-shrink: 0;
	.fields {
		font-size: 16px;
		color: var(--gray-g-700, #5c5c5c);
		font-family: Nunito Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		color: var(--color-font-grey);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		gap: 5px;

		span {
			font-weight: 700;
		}
	}
	@media screen and (max-width: 750px) {
		flex-direction: column;
		gap: 14px;
	}
`;

const StyledDataGridHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	@media screen and (max-width: 750px) {
		gap: 15px;
		flex-direction: column;
	}
`;

const SelectedItemsContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
	font-size: 16px;
	font-weight: 750;
	line-height: 21.82px;
	transition: width 0.3s ease;
`;
interface MediaQueries {
	'@media (max-width: 750px)': React.CSSProperties;
}

const stylingDeleteModal: React.CSSProperties & MediaQueries = {
	// @ts-ignore
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '306px',
	height: '375px',
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	'@media (max-width: 750px)': {
		width: '306px',
	},
};

//For Mobile View
const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 72px;
	padding: 16px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 10;
	flex-shrink: 0; // Prevents resizing when the content overflows

	position: absolute;
	bottom: 0;
`;

const StyledMobileContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
	width: 100%;
	#order-details {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 16px;
		flex-shrink: 0;
		.field {
			display: flex;
			gap: 6px;
			color: #5c5c5c;
			font-size: 14px;
			font-weight: 500;
			span {
				font-weight: 700;
			}
		}
	}
	#filter-container {
		display: flex;
		gap: 10px;
	}
`;

const ProductContainer = styled.div({
	background: '#F1F1F1',
	paddingTop: '2px',
	overflowY: 'auto',
	flexGrow: 1, // Ensure it takes up remaining space and allows scrolling
});

const SelectedItemsText = styled.div`
	color: #7d7d7d;
	font-size: 13px;
	font-weight: 600;
	margin-top: 4px;
`;

const gridResponsiveStyles: any = {
	'@media (max-width: 478px)': {
		maxHeight: 'calc(100vh - 300px)',
		minHeight: 'calc(100vh - 300px)',
		paddingBottom: '25px',
	},
};
const productDetailsModalStyles = {
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	maxWidth: '600px',
	maxHeight: '444px',
	'@media (max-width: 600px)': {
		width: '90%',
		maxWidth: '90%',
		maxHeight: '645px',
		height: '645px',
	},
};
interface Order {
	orderId: string;
	cheeniOrderId: string;
	orderDate: string;
	deliveryDate: string;
	requestedDeliveryDate: string;
	customerId: string;
	firstname: string;
	lastname: string;
	timeId: string;
	orderStatus: {
		color: string | undefined;
		color_bg: string | undefined;
		name: string | undefined;
		validation_order: number;
		id: number;
	};
	comments: string;
	total: number;
	vendorId: string;
	products: Product[];
}

interface UpdateOrderFormat {
	requestedDate: Date | null | string;
	comments: string | '';
	products: Product[];
}
type ActionType = 'ADD' | 'UPDATE' | 'DELETE';
interface OrderData {
	requestedDate: Date | null | string;
	comments: string | '';
	products: Product[];
}

const EditOrder = () => {
	const { apiService }: any = React.useContext(ApplicationContext);

	const isMobileWidth = IsMobileWidth();
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const { id, waId, orderId } = useParams();
	const [isErrorVisible, setErrorVisible] = useState(false);
	const [alert, setAlert] = useState<CustomAlertType>({ message: '', severity: 'success' });
	const [errorMessage, setErrorMessage] = useState('');

	const [editOrderFields, setEditOrderFields] = useState(false);
	const [orderDate, setOrderDate] = useState<Date | null | string>(null);
	const [deliveryDate, setDeliveryDate] = useState<Date | null | string>(null);
	const [comment, setComment] = useState<string>('');
	const [searchValue, setSearchValue] = useState('');
	const [deleteProductModal, setdeleteProductModal] = useState(false);
	const [selectedItemIds, setSelectedItemIds] = useState<string[]>([]);
	const [orderDetails, setOrderDetails] = useState<Order | null>(null);
	const [btnLoading, setBtnLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [initialOrderData, setInitialOrderData] = useState<UpdateOrderFormat>({
		requestedDate: '',
		comments: '',
		products: [],
	});
	const [addProductsComponent, setAddProductsComponent] = useState(false);
	const [products, setProducts] = useState<Product[]>([]);
	const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
	const [orderBookProducts, setOrderBookProducts] = useState<any[]>([]);
	const [filteredOrderBookProducts, setFilteredOrderBookProducts] = useState<any[]>([]);
	const [disable, setDisable] = useState(false);
	const [productDetailsModal, setProductDetailsModal] = useState(false);
	const [productDetailsData, setProductDetailsData] = useState([]);
	const [collapse, setCollapse] = useState(false);
	const [orderFieldsDrwer, setOrderFieldsDrawer] = useState(false);
	const [commentPreview, setCommentPreview] = useState(false);
	const [searchInput, setSearchInput] = useState('');
	const [categories, setCategories] = useState<Category[]>([]);
	const [detailsMiodal, setDetailsModal] = useState(false);
	const [details, setDetails] = useState([]);
	const [filters, setFilters] = useState<Filters | null>(null);
	const [activeFilter, setActiveFilter] = useState('');
	const [totalCount, setTotalCount] = useState(0);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [searching, setSearching] = useState<boolean>(false);
	const [loadingProducts, setLoadingProducts] = useState<boolean>(false);
	const [categoryOptions, setCategoryOptions] = useState<Option[]>([]);
	const [selectedIndex, setSelectedIndex] = useState<string | number>(isMobileWidth ? 1000 : '');
	const limit = 25;

	//Mobile Screen States
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const timeoutHandler = useRef<TimeoutHandler>(null);

	//Permission
	const checkPermission = usePermission();
	const editOrderPermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.UPDATE, waId);
	const canViewOrderBook = checkPermission(ALL_PERMISSION_MAP?.RESTAURANT?.ORDER_BOOK?.VIEW, waId);

	const columns = [
		// { field: 'id', headerName: 'Product ID', width: 150, align: 'center', headerAlign: 'center' },
		{
			field: 'name',
			headerName: 'Part Name',
			width: 300,
			renderCell: (params: any) => {
				const name = params?.row?.name;
				return (
					<div
						style={{
							display: 'flex',
							gap: '8px',
							alignItems: 'center',
						}}
						title={name}
					>
						<img
							style={{ objectFit: 'contain' }}
							src={
								params?.row?.images?.[0]?.image ||
								params?.row?.images?.[0]?.url ||
								params?.row?.image ||
								'/placeholderImage.svg'
							}
							alt="product-img"
							width="24px"
							height="24px"
						/>
						{params?.row?.name?.length > 33 ? (
							<CustomTooltip title={params?.row?.name} placement="top">
								<p
									style={{
										maxWidth: '260px',
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{params?.row?.name}
								</p>
							</CustomTooltip>
						) : (
							<p
								style={{
									maxWidth: '260px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{params?.row?.name}
							</p>
						)}
					</div>
				);
			},
		},
		{ field: 'unit', headerName: 'Unit', width: 150 },
		{
			field: 'quantity',
			headerName: '',
			width: 150,
			renderCell: (params: any) => (
				<Box
					sx={{
						alignItems: 'center',
						width: '100%',
						height: '38px',
						display: 'flex',
						borderRadius: '4px',
						background: '#FDFDFD',
						border: '1.5px solid #F1F1F1',
						justifyContent: 'space-between',
						padding: '0 4px',
					}}
				>
					<IconButton
						size="small"
						onClick={() => decreaseQuantity(params?.row?.id)}
						disabled={false}
					>
						<DecQuantityIcon />
					</IconButton>
					<span>{params.row.quantity}</span>
					<IconButton size="small" onClick={() => increaseQuantity(params?.row?.id)}>
						<IncQuantityIcon />
					</IconButton>
				</Box>
			),
		},
		{
			field: 'recommend',
			headerName: 'Recommended',
			width: 150,
			renderCell: (params: any) => {
				return (
					<div
						id="recommend"
						onClick={() => recommendedQuantity(params?.row?.id)}
						style={{
							alignItems: 'center',
							background: '#EDEDED',
							width: '100%',
							height: '38px',
							display: 'flex',
							borderRadius: '4px',
							justifyContent: 'center',
							cursor: 'pointer',
						}}
					>
						{params.row.recommend}
					</div>
				);
			},
		},
	];

	const decreaseQuantity = (id: string) => {
		setProducts((prevState: any) => {
			return prevState?.map((product: any) => {
				if (product?.id === id && Number(product?.quantity) > 1) {
					return { ...product, quantity: Number(product?.quantity) - 1 };
				}
				return product;
			});
		});
		setFilteredProducts((prevState: any) => {
			return prevState?.map((product: any) => {
				if (product?.id === id && Number(product?.quantity) > 1) {
					return { ...product, quantity: Number(product?.quantity) - 1 };
				}
				return product;
			});
		});
	};
	const increaseQuantity = (id: string) => {
		setProducts((prevState: any) => {
			return prevState?.map((product: any) => {
				if (product?.id === id) {
					return { ...product, quantity: Number(product?.quantity) + 1 };
				}
				return product;
			});
		});
		setFilteredProducts((prevState: any) => {
			return prevState?.map((product: any) => {
				if (product?.id === id) {
					return { ...product, quantity: Number(product?.quantity) + 1 };
				}
				return product;
			});
		});
	};

	const recommendedQuantity = (id: string) => {
		setProducts((prevState: any) => {
			return prevState?.map((product: any) => {
				if (product?.id === id) {
					return { ...product, quantity: product?.recommend };
				}
				return product;
			});
		});
		setFilteredProducts((prevState: any) => {
			return prevState?.map((product: any) => {
				if (product?.id === id) {
					return { ...product, quantity: product?.recommend };
				}
				return product;
			});
		});
	};

	const navigate = useNavigate();

	const handleArrowBack = () => {
		navigate(-1);
	};

	const displayCustomError = (msg: string) => {
		setErrorMessage(msg);
		setErrorVisible(true);
	};

	const handleErrorClose = () => {
		setErrorMessage('');
		setErrorVisible(false);
	};

	const handleSearch = (value: any) => {
		setSearchInput(value);

		const filteredProducts: any = products?.filter((product: any) => {
			const lowerCaseValue = value?.toLowerCase();

			// Check if the catalog's name, category or id includes the search value
			return (
				product?.name?.toLowerCase()?.includes(lowerCaseValue) ||
				product?.id?.toString()?.includes(lowerCaseValue) ||
				product?.category?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.machineModel?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.machineBrand?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.brand?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.subCategory?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.partDimension?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.partDesign?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.partWeight?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.partComposition?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.groupCategory?.toString().toLowerCase().includes(lowerCaseValue) ||
				product?.sku?.toString().toLowerCase().includes(lowerCaseValue)
			);
		});
		setFilteredProducts(filteredProducts);
	};
	const handleConfirm = () => {
		setProducts((prevState: any) => {
			return prevState?.filter((product: any) => !selectedItemIds.includes(product?.id));
		});
		setFilteredProducts((prevState: any) => {
			return prevState?.filter((product: any) => !selectedItemIds.includes(product?.id));
		});

		//added remove products into orderbook
		const removeProducts = products?.filter((product: any) =>
			selectedItemIds.includes(product?.id)
		);
		const updatedProducts = removeProducts?.map((item: any) => {
			return { ...item, isSelection: false };
		});
		setTotalCount((prevState: number) => prevState + removeProducts?.length);
		setOrderBookProducts([...updatedProducts, ...orderBookProducts]);
		setFilteredOrderBookProducts([...updatedProducts, ...orderBookProducts]);
		setdeleteProductModal(false);
		setSelectedItemIds([]);
	};

	const handleOrderDate = (date: Date | null) => {
		setOrderDate(date);
	};

	const handleRequestDeliveryDate = (date: Date | null) => {
		setDeliveryDate(convertUTCDateIntoIndianTimezone(date as Date));
	};
	const handleClose = () => {
		setEditOrderFields(false);
	};

	const changeComponent = () => {
		setAddProductsComponent(true);
	};

	const checkChanges = () => {
		const initialOrderDataCopy = { ...initialOrderData };
		const updatedDataCopy = {
			requestedDate: deliveryDate ? moment(new Date(deliveryDate)).format('DD-MM-YYYY') : '',
			comments: comment,
			products: (products || []).map(({ isSelection, ...rest }) => rest),
		};

		return deepEqual(initialOrderDataCopy, updatedDataCopy);
	};

	const isRequestDeliveryChanged = (
		updatedDate: string | Date | null,
		initialDate: string | Date | null
	) => {
		return updatedDate !== initialDate;
	};

	const isCommentsChanged = (updatedComments: string | '', initialComments: string | '') => {
		return updatedComments !== initialComments;
	};
	const validationsUpdateOrder = () => {
		if (!filteredProducts?.length) {
			displayCustomError('Order must contain 1 item');
			setDisable(false);
			return false;
		}
		return true;
	};
	const updateOrder = () => {
		if (products?.some((product: any) => product?.quantity === 0)) {
			displayCustomError('Some items have zero quantity. Please review your selections.');
			return;
		}

		setDisable(true);
		setBtnLoading(true);
		const items = [...products];
		const updatedData: OrderData = {
			requestedDate: deliveryDate ? moment(new Date(deliveryDate)).format('DD-MM-YYYY') : '',
			comments: comment,
			products: items || [],
		};

		const allProducts: any = [];

		if ('products' in initialOrderData) {
			for (let i = 0; i < updatedData?.products?.length; i++) {
				const updatedProduct: any = updatedData?.products[i];
				const initialProduct = initialOrderData?.products.find(
					(product: any) => Number(product?.productId) === Number(updatedProduct?.productId)
				);

				if (initialProduct) {
					if (initialProduct?.quantity !== updatedProduct?.quantity) {
						allProducts.push({
							type: 'UPDATE',
							productId: Number(updatedProduct?.productId),
							quantity: updatedProduct?.quantity,
						});
					}
				} else {
					allProducts.push({
						type: 'ADD',
						productId: Number(updatedProduct?.productId),
						quantity: updatedProduct?.quantity,
					});
				}
			}

			for (let i = 0; i < initialOrderData?.products?.length; i++) {
				const initialProduct: any = initialOrderData?.products[i];
				const productExistsInUpdatedData = updatedData?.products.some(
					(product) => Number(product?.productId) === Number(initialProduct?.productId)
				);

				if (!productExistsInUpdatedData) {
					allProducts.push({
						type: 'DELETE',
						productId: Number(initialProduct?.productId),
						quantity: initialProduct?.quantity,
					});
				}
			}
		}

		const data = cleanObject({
			comments: isCommentsChanged(updatedData?.comments, initialOrderData?.comments) ? comment : '',
			requestedDate: isRequestDeliveryChanged(
				updatedData?.requestedDate,
				initialOrderData?.requestedDate
			)
				? deliveryDate
				: '',
			products: allProducts,
		});

		if (validationsUpdateOrder() && orderDetails && 'cheeniOrderId' in orderDetails) {
			if (editOrderPermission) {
				apiService.updateOrder(
					data,
					(response: AxiosResponse) => {
						setDisable(false);
						setBtnLoading(false);
						setAlert({
							message: 'Order Updated Successfully',
							severity: 'success',
						});

						//next call
						getOrderAndOrdebookItems();
					},
					(error: AxiosError) => {
						setDisable(false);
						setBtnLoading(false);
						displayCustomError('Something went wrong!');
					},
					id,
					orderDetails?.cheeniOrderId
				);
			}
		} else {
			setBtnLoading(false);
		}
	};

	const fieldsView = () => {
		return (
			<FieldsContainer>
				<div id="orderNo">
					<h3>Order# {orderDetails?.timeId}</h3>

					{windowDimensions?.width > 750 ? (
						<CustomButton
							title={
								btnLoading ? (
									<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
								) : (
									'Update'
								)
							}
							handleClick={updateOrder}
							color="primary"
							styles={{
								width: '134px',
								height: '36px',
								marginRight: '16px',
							}}
							disabled={checkChanges() || disable}
						/>
					) : (
						<CustomButton
							title="Add New Product"
							handleClick={changeComponent}
							color="primary"
							styles={{
								width: '178px',
								height: '36px',
							}}
							disabled={disable || !orderBookProducts?.length}
						/>
					)}
				</div>
				<DateFieldsContainer>
					<CustomDatePicker
						label="Ordered"
						styles={{ width: windowDimensions?.width > 750 ? '281px' : '88vw', height: '36px' }}
						selectedDate={orderDate}
						onDateChange={handleOrderDate}
						disabled
					/>
					<CustomDatePicker
						label="Request Delivery"
						styles={{ width: windowDimensions?.width > 750 ? '281px' : '88vw', height: '36px' }}
						minDate={orderDate}
						selectedDate={deliveryDate}
						onDateChange={handleRequestDeliveryDate}
					/>
				</DateFieldsContainer>
				<LabeledTextField
					label="Leave a comment"
					value={comment}
					onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
						setComment(e?.target?.value as string)
					}
					styles={{ width: windowDimensions?.width > 750 ? '586px' : '95vw', height: '36px' }}
					placeholder="leave a comment"
					multiline
					rows={4}
				/>
			</FieldsContainer>
		);
	};

	// const mobileFieldsContainer = () => {
	// 	return (
	// 		<div
	// 			style={{
	// 				display: 'flex',
	// 				flexDirection: 'column',
	// 				gap: '14px',
	// 				marginTop: '40px',
	// 				overflow: 'hidden',
	// 			}}
	// 		>
	// 			<div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
	// 				<DateFieldsContainer>
	// 					<div style={{ width: '100%', paddingLeft: '16px', paddingRight: '16px' }}>
	// 						<CustomDatePicker
	// 							label="Ordered"
	// 							styles={{ width: '100%' }}
	// 							labelStyles={{ fontSize: '14px' }}
	// 							selectedDate={orderDate}
	// 							onDateChange={handleOrderDate}
	// 							disabled
	// 						/>
	// 					</div>

	// 					<div style={{ width: '100%', paddingLeft: '16px', paddingRight: '16px' }}>
	// 						<CustomDatePicker
	// 							label="Request Delivery"
	// 							styles={{ width: '100%' }}
	// 							labelStyles={{ fontSize: '14px' }}
	// 							minDate={orderDate}
	// 							selectedDate={deliveryDate}
	// 							onDateChange={handleRequestDeliveryDate}
	// 						/>
	// 					</div>
	// 				</DateFieldsContainer>
	// 				<div style={{ paddingLeft: '16px', paddingRight: '16px', width: '100%' }}>
	// 					<LabeledTextField
	// 						label="Leave a comment"
	// 						value={comment}
	// 						onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
	// 							setComment(e?.target?.value as string)
	// 						}
	// 						styles={{ width: '100%' }}
	// 						placeholder="leave a comment"
	// 						multiline
	// 						rows={4}
	// 					/>
	// 				</div>
	// 			</div>
	// 			<StyledBottomBtnContainer style={{ position: 'absolute', bottom: 0 }}>
	// 				<div style={{ display: 'flex', gap: '10px', padding: '10px' }}>
	// 					<CustomButton
	// 						title="Cancel"
	// 						styles={{
	// 							width: '118px',
	// 							height: '40px',
	// 							background: 'var(--btn-color-grey)',
	// 							color: 'var(--default-text-color)',
	// 							':hover': {
	// 								background: 'var(--btn-hover-color) !important',
	// 							},
	// 							transition: 'background 0.3s ease, color 0.3s ease',
	// 						}}
	// 						handleClick={() => setOrderFieldsDrawer(false)}
	// 					/>
	// 					<CustomButton
	// 						title={
	// 							btnLoading ? (
	// 								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
	// 							) : (
	// 								'Update'
	// 							)
	// 						}
	// 						handleClick={updateOrder}
	// 						color="primary"
	// 						styles={{
	// 							width: '187px',
	// 							height: '40px',
	// 						}}
	// 						disabled={checkChanges() || disable}
	// 					/>
	// 				</div>
	// 			</StyledBottomBtnContainer>
	// 		</div>
	// 	);
	// };

	const onRowsSelectionHandler = (ids: any) => {
		setSelectedItemIds(ids);
	};

	const handleRowClick = (params: any, event: any) => {
		// const data: any = products?.find((product: any) => product?.id === params?.id);
		// const details: any = [
		// 	{
		// 		name: data?.name,
		// 		image: data?.image || '/prodcut.png',
		// 		description: data?.description,
		// 		details: [`Part Category: ${data?.category}`, `Unit: ${data?.unit}`, `Price: ${data?.price}`],
		// 	},
		// ];
		// setProductDetailsData(details);
		// setProductDetailsModal(true);
	};

	const getOrderDetailsPromise = () => {
		return new Promise<Order>((resolve, reject) => {
			apiService.getOrderDetails(
				(response: AxiosResponse) => {
					resolve(response.data.data as Order);
				},
				(error: AxiosError) => {
					reject(error);
				},
				id,
				orderId
			);
		});
	};

	const getOrderbookItemsPromise = () => {
		return new Promise<any[]>((resolve, reject) => {
			apiService.getOrderbookItems(
				(response: AxiosResponse) => {
					resolve(response.data.data);
				},
				(error: AxiosError) => {
					reject(error);
				},
				waId,
				id,
				{
					page: page,
					limit: limit,
					search: searchValue,
					machineModel: filters?.model?.id,
					subCategory: filters?.subCategory?.id,
					machineBrand: filters?.machineBrand?.id,
					dimension: filters?.dimension?.id,
					design: filters?.design?.id,
					weight: filters?.weight?.id,
					composition: filters?.composition?.id,
					brand: filters?.brand?.id,
				}
			);
		});
	};

	const getAllItems = () => {
		return new Promise<any[]>((resolve, reject) => {
			apiService.getAllRestaurantProducts(
				(response: AxiosResponse) => {
					resolve(response.data.data);
				},
				(error: AxiosError) => {
					reject(error);
				},
				waId,
				{
					page: page,
					limit: limit,
					search: searchValue,
					machineModel: filters?.model?.id,
					subCategory: filters?.subCategory?.id,
					machineBrand: filters?.machineBrand?.id,
					dimension: filters?.dimension?.id,
					design: filters?.design?.id,
					weight: filters?.weight?.id,
					composition: filters?.composition?.id,
					brand: filters?.brand?.id,
				}
			);
		});
	};

	const handleSelectAll = (products: any) => {
		const ids: string[] =
			selectedItemIds?.length === filteredProducts?.length
				? []
				: filteredProducts?.map((item: any) => item?.id);
		setProducts((prevState: any) => {
			return prevState?.map((item: any) => {
				return {
					...item,
					isSelection: !(selectedItemIds?.length === filteredProducts?.length),
				};
			});
		});
		setFilteredProducts((prevState: any) => {
			return prevState?.map((item: any) => {
				return {
					...item,
					isSelection: !(selectedItemIds?.length === filteredProducts?.length),
				};
			});
		});

		setSelectedItemIds(ids);
	};

	const handleSpecificProductSelect = (id: any) => {
		const ids: string[] = [];
		setProducts((prevState: any) => {
			return prevState?.map((item: any) => {
				if (item?.id === id) {
					return {
						...item,
						isSelection: !item?.isSelection,
					};
				}
				return item;
			});
		});
		setFilteredProducts((prevState: any) => {
			return prevState?.map((item: any) => {
				if ((item?.id !== id && item?.isSelection) || (item?.id === id && !item?.isSelection)) {
					ids.push(item?.id);
				}
				if (item?.id === id) {
					return {
						...item,
						isSelection: !item?.isSelection,
					};
				}
				return item;
			});
		});
		setSelectedItemIds(ids);
	};

	const btnView = () => {
		return selectedItemIds?.length ? (
			<CustomButton
				title="Delete Item(s)"
				handleClick={() => handleConfirm()}
				styles={{
					width: '320px',
					height: '40px',
					background: '#F26184',
					color: '#FFFFFF',
					transition: 'background 0.3s ease, color 0.3s ease',
				}}
			/>
		) : (
			<>
				<CustomButton
					title="Edit Order"
					styles={{
						width: '136px',
						height: '40px',
						background: 'var(--btn-color-grey)',
						color: 'var(--default-text-color)',
						':hover': {
							background: 'var(--btn-hover-color) !important',
						},
						transition: 'background 0.3s ease, color 0.3s ease',
					}}
					handleClick={() => setOrderFieldsDrawer(true)}
				/>
				<CustomButton
					title="Add New Product"
					handleClick={() => setAddProductsComponent(true)}
					styles={{
						width: '178px',
						height: '40px',
						transition: 'background 0.3s ease, color 0.3s ease',
					}}
					disabled={!orderBookProducts?.length}
				/>
			</>
		);
	};

	const showDetails = (product: any) => {
		setDetails(product);
		setDetailsModal(true);
	};

	const setCategoriesforSlider = (supplierProductsResponse: any) => {
		const categories: Category[] = supplierProductsResponse?.map((product: any) => {
			return { category_id: product?.category?.id, name: product?.category?.name };
		});

		// Filter out duplicate categories
		const uniqueCategories = categories?.reduce((acc, current) => {
			//@ts-ignore
			const x = acc.find((item) => item?.category_id === current?.category_id);
			if (!x) {
				//@ts-ignore
				acc?.push(current);
			}
			return acc;
		}, []);

		apiService.getProductCategories(
			(res: AxiosResponse) => {
				const data = [{ category_id: 1000, name: 'All', image: '/Icons/All.png' }];
				uniqueCategories?.forEach((category) => {
					const image = res?.data?.data?.categories?.find(
						//@ts-ignore
						(item: any) => item?.category_id === category?.category_id
					)?.image;
					//@ts-ignore
					data.push({ ...category, image: image });
				});

				setCategories(data);
			},
			(error: AxiosError) => {
				displayCustomError('Somethin went wrong');
			}
		);
	};

	const getOrderAndOrdebookItems = () => {
		if (currentUser?.type?.toLowerCase() === RESTAURANT) {
			if (canViewOrderBook) {
				Promise.all([getOrderDetailsPromise(), getOrderbookItemsPromise()])
					.then(([orderDetailsResponse, supplierProductsResponse]) => {
						//order edit permissions
						if (
							orderDetailsResponse &&
							!canEditOrder(orderDetailsResponse?.orderStatus?.validation_order) &&
							currentUser?.type?.toLowerCase() !== RESTAURANT
						) {
							navigate(-1);
							return;
						}
						// Handle orderDetailsResponse and orderBookProducts here
						setOrderDetails(orderDetailsResponse);
						setInitialOrderData({
							requestedDate:
								moment(orderDetailsResponse?.requestedDeliveryDate).format('DD-MM-YYYY') || '',
							comments: orderDetailsResponse?.comments || '',
							products:
								orderDetailsResponse?.products?.map((item: any) => {
									return {
										...item,
										quantity: Number(item?.quantity),
										id: item?.productId,
										recommend: item?.recommend || '1',
										category: item?.category?.name,
										categoryId: item?.category?.id,
										subCategory: item?.subCategory?.name,
										subCategoryId: item?.subCategory?.id,
										maxPrice: formatPriceValue(item?.maxPrice),
										machineBrand: item?.machineBrand?.name,
										machineBrandId: item?.machineBrand?.id,
										machineModel: item?.machineModel?.name,
										machineModelId: item?.machineModel?.id,
										groupCategory: item?.groupCategory?.name,
										groupCategoryId: item?.groupCategory?.id,
										brand: item?.brand?.name,
										brandId: item?.brand?.id,
										partComposition: item?.partComposition?.name,
										partCompositionId: item?.partComposition?.id,
										partDesign: item?.partDesign?.name,
										partDesignId: item?.partDesign?.id,
										partDiameter: item?.partDiameter?.name,
										partDiameterId: item?.partDiameter?.id,
										partDimension: item?.partDimension?.name,
										partDimensionId: item?.partDimension?.id,
										partOwnership: item?.partOwnership?.name,
										partOwnershipId: item?.partOwnership?.id,
										partQuality: item?.partQuality?.name,
										partQualityId: item?.partQuality?.id,
										partWeight: item?.partWeight?.name,
										partWeightId: item?.partWeight?.id,
										partPerformance: item?.partPerformance?.name,
										partPerformanceId: item?.partPerformance?.id,
									};
								}) || [],
						});
						setOrderDate(orderDetailsResponse?.orderDate);
						setComment(orderDetailsResponse?.comments || '');
						setDeliveryDate(orderDetailsResponse?.requestedDeliveryDate);
						const updatedOrderProducts = orderDetailsResponse?.products?.map((item: Product) => {
							return {
								...item,
								quantity: Number(item?.quantity),
								id: item?.productId,
								recommend: item?.recommend || '1',
								unit: item?.unit,
								category: item?.category?.name,
								categoryId: item?.category?.id,
								subCategory: item?.subCategory?.name,
								subCategoryId: item?.subCategory?.id,
								maxPrice: formatPriceValue(item?.maxPrice),
								machineBrand: item?.machineBrand?.name,
								machineBrandId: item?.machineBrand?.id,
								machineModel: item?.machineModel?.name,
								machineModelId: item?.machineModel?.id,
								groupCategory: item?.groupCategory?.name,
								groupCategoryId: item?.groupCategory?.id,
								brand: item?.brand?.name,
								brandId: item?.brand?.id,
								partComposition: item?.partComposition?.name,
								partCompositionId: item?.partComposition?.id,
								partDesign: item?.partDesign?.name,
								partDesignId: item?.partDesign?.id,
								partDiameter: item?.partDiameter?.name,
								partDiameterId: item?.partDiameter?.id,
								partDimension: item?.partDimension?.name,
								partDimensionId: item?.partDimension?.id,
								partOwnership: item?.partOwnership?.name,
								partOwnershipId: item?.partOwnership?.id,
								partQuality: item?.partQuality?.name,
								partQualityId: item?.partQuality?.id,
								partWeight: item?.partWeight?.name,
								partWeightId: item?.partWeight?.id,
								partPerformance: item?.partPerformance?.name,
								partPerformanceId: item?.partPerformance?.id,
							};
						});
						setProducts(updatedOrderProducts);
						setFilteredProducts(updatedOrderProducts);

						//orderBookProducts
						const productIds = orderDetailsResponse?.products?.map(
							(product: Product) => product?.productId
						);
						const orderBookProducts = supplierProductsResponse?.items
							?.filter((item: any) => !productIds.includes(item?.productId))
							?.map((item: any) => ({
								...item,
								name: item.productName,
								category: item?.category?.name,
								categoryId: item?.category?.id,
								categoryObject: { id: item?.category?.id, value: item?.category?.name },
								id: item.productId,
								unit: item.unit,
								price: item.customerPrice,
								quantity: item.quantity,
								recommend: item?.recommend,
								maxPrice: item?.maxPrice,
								subCategory: item?.subCategory?.name,
								subCategoryId: item?.subCategory?.id,
								machineBrand: item?.machineBrand?.name,
								machineBrandId: item?.machineBrand?.id,
								machineModel: item?.machineModel?.name,
								machineModelId: item?.machineModel?.id,
								groupCategory: item?.groupCategory?.name,
								groupCategoryId: item?.groupCategory?.id,
								brand: item?.brand?.name,
								brandId: item?.brand?.id,
								partComposition: item?.partComposition?.name,
								partCompositionId: item?.partComposition?.id,
								partDesign: item?.partDesign?.name,
								partDesignId: item?.partDesign?.id,
								partDiameter: item?.partDiameter?.name,
								partDiameterId: item?.partDiameter?.id,
								partDimension: item?.partDimension?.name,
								partDimensionId: item?.partDimension?.id,
								partOwnership: item?.partOwnership?.name,
								partOwnershipId: item?.partOwnership?.id,
								partQuality: item?.partQuality?.name,
								partQualityId: item?.partQuality?.id,
								partWeight: item?.partWeight?.name,
								partWeightId: item?.partWeight?.id,
								partPerformance: item?.partPerformance?.name,
								partPerformanceId: item?.partPerformance?.id,
							}));
						if (page === 1) {
							setOrderBookProducts(orderBookProducts);
						} else {
							//@ts-ignore
							setOrderBookProducts((prevState: any) => [...prevState, ...orderBookProducts]);
						}

						const totalCount: number =
							supplierProductsResponse?.totalCount - updatedOrderProducts?.length;
						const totalPages: number = Math.max(Math.ceil(totalCount / limit), 1);
						setTotalCount(totalCount);
						setTotalPages(totalPages);
						setIsLoading(false);
						setLoadingProducts(false);
						setSearching(false);
					})
					.catch((error) => {
						// Handle errors here
						setIsLoading(false);
						setLoadingProducts(false);
						setSearching(false);

						displayCustomError('Something went wrong!');
						console.log(error);
					});
			} else {
				setIsLoading(false);
				setLoadingProducts(false);
				setSearching(false);
			}
		} else {
			Promise.all([getOrderDetailsPromise(), getAllItems()])
				.then(([orderDetailsResponse, supplierProductsResponse]) => {
					//order edit permissions
					if (
						orderDetailsResponse &&
						!canEditOrder(orderDetailsResponse?.orderStatus?.validation_order) &&
						currentUser?.type?.toLowerCase() !== RESTAURANT
					) {
						navigate(-1);
						return;
					}
					// Handle orderDetailsResponse and orderBookProducts here
					setOrderDetails(orderDetailsResponse);
					setInitialOrderData({
						requestedDate:
							moment(orderDetailsResponse?.requestedDeliveryDate).format('DD-MM-YYYY') || '',
						comments: orderDetailsResponse?.comments || '',
						products:
							orderDetailsResponse?.products?.map((item: any) => {
								return {
									...item,
									quantity: Number(item?.quantity),
									id: item?.productId,
									recommend: item?.recommend || '1',
									category: item?.category?.name,
									categoryId: item?.category?.id,
									subCategory: item?.subCategory?.name,
									subCategoryId: item?.subCategory?.id,
									maxPrice: formatPriceValue(item?.maxPrice),
									machineBrand: item?.machineBrand?.name,
									machineBrandId: item?.machineBrand?.id,
									machineModel: item?.machineModel?.name,
									machineModelId: item?.machineModel?.id,
									groupCategory: item?.groupCategory?.name,
									groupCategoryId: item?.groupCategory?.id,
									brand: item?.brand?.name,
									brandId: item?.brand?.id,
									partComposition: item?.partComposition?.name,
									partCompositionId: item?.partComposition?.id,
									partDesign: item?.partDesign?.name,
									partDesignId: item?.partDesign?.id,
									partDiameter: item?.partDiameter?.name,
									partDiameterId: item?.partDiameter?.id,
									partDimension: item?.partDimension?.name,
									partDimensionId: item?.partDimension?.id,
									partOwnership: item?.partOwnership?.name,
									partOwnershipId: item?.partOwnership?.id,
									partQuality: item?.partQuality?.name,
									partQualityId: item?.partQuality?.id,
									partWeight: item?.partWeight?.name,
									partWeightId: item?.partWeight?.id,
									partPerformance: item?.partPerformance?.name,
									partPerformanceId: item?.partPerformance?.id,
								};
							}) || [],
					});
					setOrderDate(orderDetailsResponse?.orderDate);
					setComment(orderDetailsResponse?.comments || '');
					setDeliveryDate(orderDetailsResponse?.requestedDeliveryDate);
					const updatedOrderProducts = orderDetailsResponse?.products?.map((item: Product) => {
						return {
							...item,
							quantity: Number(item?.quantity),
							id: item?.productId,
							recommend: item?.recommend || '1',
							category: item?.category?.name,
							categoryId: item?.category?.id,
							subCategory: item?.subCategory?.name,
							subCategoryId: item?.subCategory?.id,
							maxPrice: formatPriceValue(item?.maxPrice),
							machineBrand: item?.machineBrand?.name,
							machineBrandId: item?.machineBrand?.id,
							machineModel: item?.machineModel?.name,
							machineModelId: item?.machineModel?.id,
							groupCategory: item?.groupCategory?.name,
							groupCategoryId: item?.groupCategory?.id,
							brand: item?.brand?.name,
							brandId: item?.brand?.id,
							partComposition: item?.partComposition?.name,
							partCompositionId: item?.partComposition?.id,
							partDesign: item?.partDesign?.name,
							partDesignId: item?.partDesign?.id,
							partDiameter: item?.partDiameter?.name,
							partDiameterId: item?.partDiameter?.id,
							partDimension: item?.partDimension?.name,
							partDimensionId: item?.partDimension?.id,
							partOwnership: item?.partOwnership?.name,
							partOwnershipId: item?.partOwnership?.id,
							partQuality: item?.partQuality?.name,
							partQualityId: item?.partQuality?.id,
							partWeight: item?.partWeight?.name,
							partWeightId: item?.partWeight?.id,
							partPerformance: item?.partPerformance?.name,
							partPerformanceId: item?.partPerformance?.id,
						};
					});

					setProducts(updatedOrderProducts);
					setFilteredProducts(updatedOrderProducts);

					//orderBookProducts
					const productIds = orderDetailsResponse?.products?.map(
						(product: Product) => product?.productId
					);
					const orderBookProducts = supplierProductsResponse?.products
						?.filter((item: any) => !productIds.includes(item?.productId))
						?.map((item: any) => ({
							...item,
							name: item.productName,
							category: item?.category?.name,
							categoryId: item?.category?.id,
							categoryObject: { id: item?.category?.id, value: item?.category?.name },
							id: item.productId,
							unit: item.unit,
							price: item.customerPrice,
							quantity: item.quantity,
							recommend: item?.recommend,
							maxPrice: item?.maxPrice,
							subCategory: item?.subCategory?.name,
							subCategoryId: item?.subCategory?.id,
							machineBrand: item?.machineBrand?.name,
							machineBrandId: item?.machineBrand?.id,
							machineModel: item?.machineModel?.name,
							machineModelId: item?.machineModel?.id,
							groupCategory: item?.groupCategory?.name,
							groupCategoryId: item?.groupCategory?.id,
							brand: item?.brand?.name,
							brandId: item?.brand?.id,
							partComposition: item?.partComposition?.name,
							partCompositionId: item?.partComposition?.id,
							partDesign: item?.partDesign?.name,
							partDesignId: item?.partDesign?.id,
							partDiameter: item?.partDiameter?.name,
							partDiameterId: item?.partDiameter?.id,
							partDimension: item?.partDimension?.name,
							partDimensionId: item?.partDimension?.id,
							partOwnership: item?.partOwnership?.name,
							partOwnershipId: item?.partOwnership?.id,
							partQuality: item?.partQuality?.name,
							partQualityId: item?.partQuality?.id,
							partWeight: item?.partWeight?.name,
							partWeightId: item?.partWeight?.id,
							partPerformance: item?.partPerformance?.name,
							partPerformanceId: item?.partPerformance?.id,
						}));

					if (page === 1) {
						setOrderBookProducts(orderBookProducts);
					} else {
						//@ts-ignore
						setOrderBookProducts((prevState: any) => [...prevState, ...orderBookProducts]);
					}

					const totalCount: number =
						supplierProductsResponse?.totalCount - updatedOrderProducts?.length;
					const totalPages: number = Math.max(Math.ceil(totalCount / limit), 1);
					setTotalCount(totalCount);
					setTotalPages(totalPages);
					setIsLoading(false);
					setLoadingProducts(false);
					setSearching(false);
				})
				.catch((error) => {
					// Handle errors here
					setIsLoading(false);
					setLoadingProducts(false);
					setSearching(false);
					displayCustomError('Something went wrong!');
					console.log(error);
				});
		}
	};

	useEffect(() => {
		getOrderAndOrdebookItems();
	}, [id, orderId, waId, canViewOrderBook, page, filters]);

	useEffect(() => {
		//debounce
		if (timeoutHandler.current) {
			clearTimeout(timeoutHandler.current);
		}
		timeoutHandler.current = setTimeout(() => {
			try {
				getOrderAndOrdebookItems();
			} catch (err) {}
		}, 500);
	}, [searchValue]);

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	// if (isMobileWidth && !addProductsComponent) {
	// 	return (
	// 		<StyledMobileContainer>
	// 			<PageHeaderMobile
	// 				title="Edit Order"
	// 				setCollapse={setCollapse}
	// 				collapse={collapse}
	// 				onClick={() => {
	// 					navigate(-1);
	// 				}}
	// 			/>
	// 			{collapse ? (
	// 				<Collapse
	// 					in={collapse}
	// 					style={{
	// 						display: 'flex',
	// 						gap: '15px',
	// 						alignItems: 'center',
	// 						flexShrink: 0,
	// 						padding: '16px',
	// 					}}
	// 				>
	// 					<SearchBar
	// 						style={{
	// 							width: '328px',
	// 							height: '36px',
	// 						}}
	// 						value={searchValue}
	// 						onChange={handleSearch}
	// 						isLoading={false}
	// 						autoFocus
	// 					/>
	// 				</Collapse>
	// 			) : null}

	// 			<div id="order-details">
	// 				<div
	// 					style={{
	// 						display: 'flex',
	// 						justifyContent: 'space-between',
	// 						alignItems: 'center',
	// 						height: '20px',
	// 					}}
	// 				>
	// 					<div className="field" style={{ color: '#000000', fontWeight: 700 }}>
	// 						Order# {orderDetails?.timeId}
	// 					</div>
	// 					{orderDetails?.comments ? (
	// 						<IconButton onClick={() => setCommentPreview(true)}>
	// 							<CommentIcon2 />
	// 						</IconButton>
	// 					) : null}
	// 				</div>
	// 				<div className="field">
	// 					Ordered: <span>{moment(orderDetails?.orderDate).format('MMM DD, YYYY hh:mma')}</span>
	// 				</div>

	// 				<div className="field">
	// 					Request Delivery:{' '}
	// 					<span>{moment(orderDetails?.requestedDeliveryDate).format('MMM DD, YYYY')}</span>
	// 				</div>
	// 				<div id="filter-container">
	// 					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
	// 						{filteredProducts?.length ? (
	// 							<CustomTextButton
	// 								style={{
	// 									fontSize: '13px',
	// 									fontWeight: 700,
	// 									color: '#FF6120',
	// 									textDecoration: 'none',
	// 									maxWidth: '75px',
	// 									marginTop: '4px',
	// 								}}
	// 								title={
	// 									selectedItemIds?.length === filteredProducts?.length
	// 										? 'Deselect All'
	// 										: 'Select All'
	// 								}
	// 								onClick={() => handleSelectAll(filteredProducts)}
	// 							/>
	// 						) : null}
	// 						<SelectedItemsTextContainer
	// 							selectedItemIds={selectedItemIds}
	// 							filteredItems={filteredProducts}
	// 						/>
	// 					</div>
	// 				</div>
	// 			</div>
	// 			<Divider style={{ width: '100%' }} />
	// 			{filteredProducts?.length ? (
	// 				<ProductContainer>
	// 					{filteredProducts?.map((item) => (
	// 						<ProductCustomCard
	// 							key={item?.id}
	// 							//@ts-ignore
	// 							product={item}
	// 							increaseQuantity={increaseQuantity}
	// 							decreaseQuantity={decreaseQuantity}
	// 							recommendedQuantity={recommendedQuantity}
	// 							isContainCheckbox
	// 							checkBoxSelection={handleSpecificProductSelect}
	// 						/>
	// 					))}
	// 				</ProductContainer>
	// 			) : (
	// 				<div
	// 					style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}
	// 				>
	// 					{searchValue ? 'No Products Found' : 'Order must contain atleast one product'}
	// 				</div>
	// 			)}
	// 			<StyledBottomBtnContainer>
	// 				<div style={{ display: 'flex', gap: '10px', padding: '10px', flexShrink: 0 }}>
	// 					{btnView()}
	// 				</div>
	// 			</StyledBottomBtnContainer>

	// 			{orderFieldsDrwer ? (
	// 				<SlidableDrawer
	// 					isOpen={orderFieldsDrwer}
	// 					setIsOpen={setOrderFieldsDrawer}
	// 					onClose={() => {}}
	// 				>
	// 					{mobileFieldsContainer()}
	// 				</SlidableDrawer>
	// 			) : null}

	// 			{commentPreview ? (
	// 				<CustomModal
	// 					open={commentPreview}
	// 					setOpen={setCommentPreview}
	// 					style={{ width: '326px', height: '266px', background: '#F4F2F0', borderRadius: '10px' }}
	// 					title={''}
	// 					children={
	// 						<div
	// 							style={{
	// 								display: 'flex',
	// 								flexDirection: 'column',
	// 								gap: '10px',
	// 							}}
	// 						>
	// 							<div
	// 								style={{
	// 									paddingLeft: '16px',
	// 									paddingRight: '16px',
	// 									width: '326px',
	// 									height: '204px',
	// 									marginTop: '16px',
	// 								}}
	// 							>
	// 								<LabeledTextField
	// 									label="Comment"
	// 									value={comment}
	// 									onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
	// 										setComment(e?.target?.value as string)
	// 									}
	// 									styles={{ width: '100%', height: '204px !important' }}
	// 									placeholder="leave a comment"
	// 									multiline
	// 									rows={4}
	// 									readOnly
	// 								/>
	// 							</div>
	// 						</div>
	// 					}
	// 					header={false}
	// 				/>
	// 			) : null}

	// 			{alert?.message !== '' ? <CustomAlert alert={alert} setAlert={setAlert} /> : null}
	// 			<Snackbar
	// 				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
	// 				open={isErrorVisible}
	// 				autoHideDuration={6000}
	// 				onClose={handleErrorClose}
	// 			>
	// 				<Alert onClose={handleErrorClose} severity="error" elevation={4}>
	// 					{errorMessage}
	// 				</Alert>
	// 			</Snackbar>
	// 		</StyledMobileContainer>
	// 	);
	// }

	// if (isMobileWidth && addProductsComponent) {
	// 	return (
	// 		<OrderbookProducts
	// 			products={orderBookProducts}
	// 			setProducts={setOrderBookProducts}
	// 			filteredProducts={filteredOrderBookProducts}
	// 			setFilteredProducts={setFilteredOrderBookProducts}
	// 			setAddProductsComponent={setAddProductsComponent}
	// 			setOrderedFilteredProducts={setFilteredProducts}
	// 			setOrderedProducts={setProducts}
	// 			windowDimensions={windowDimensions}
	// 			categories={categories}
	// 			setCategories={setCategories}
	// 			selectedIndex={selectedIndex}
	// 			setSelectedIndex={setSelectedIndex}
	// 		/>
	// 	);
	// }

	const modals = () => {
		if (detailsMiodal && details) {
			return (
				<CustomModal
					open={detailsMiodal}
					setOpen={setDetailsModal}
					header={false}
					style={productDetailsModalStyles}
				>
					{/* @ts-ignore */}
					<ProductDetails data={details} setOpenModal={setDetailsModal} />
				</CustomModal>
			);
		}
	};

	return (
		<>
			{addProductsComponent ? (
				<OrderbookProducts
					products={orderBookProducts}
					setProducts={setOrderBookProducts}
					setAddProductsComponent={setAddProductsComponent}
					setOrderedFilteredProducts={setFilteredProducts}
					setOrderedProducts={setProducts}
					windowDimensions={windowDimensions}
					categories={categories}
					setCategories={setCategories}
					selectedIndex={selectedIndex}
					page={page}
					totalPages={totalPages}
					searching={searching}
					setSearching={setSearching}
					setPage={setPage}
					searchValue={searchValue}
					setSearchValue={setSearchValue}
					categoryOptions={categoryOptions}
					setCategoryId={setSelectedIndex}
					loadingProducts={loadingProducts}
					setLoadingProducts={setLoadingProducts}
					totalCount={totalCount}
					setTotalCount={setTotalCount}
					increaseQuantity={increaseQuantity}
					decreaseQuantity={decreaseQuantity}
					recommendedQuantity={recommendedQuantity}
				/>
			) : (
				<div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
					<PageHeader title="Edit Order" activeIcon={true} handleArrowBack={handleArrowBack} />
					<Container>
						{fieldsView()}
						<StyledDataGridHeader>
							<SearchBar
								style={{
									width: '328px',
									height: '36px',
								}}
								value={searchValue}
								onChange={handleSearch}
								isLoading={false}
							/>
							<div style={{ display: 'flex', gap: '10px' }}>
								{selectedItemIds?.length ? (
									<SelectedItemsContainer>
										<Typography>{selectedItemIds?.length} items selected</Typography>
										<IconButton onClick={() => setdeleteProductModal(true)}>
											<DeleteIcon />
										</IconButton>
									</SelectedItemsContainer>
								) : null}
								{windowDimensions?.width > 750 ? (
									<CustomButton
										title="Add New Product"
										handleClick={changeComponent}
										color="primary"
										styles={{
											width: '178px',
											height: '36px',
										}}
										disabled={disable || !orderBookProducts?.length}
									/>
								) : null}
							</div>
						</StyledDataGridHeader>
						<CustomFilter
							filters={filters}
							setFilters={setFilters}
							activeFilter={activeFilter}
							setActiveFilter={setActiveFilter}
							products={products}
							setFilteredProducts={setFilteredProducts}
						/>
						<Divider />
						{canViewOrderBook ? (
							// <CustomDataGrid2
							// 	filterOptions={[
							// 		...new Set(filteredProducts?.map((product: any) => product?.category)),
							// 	]}
							// 	rows={filteredProducts}
							// 	columns={columns}
							// 	onRowsSelectionHandler={onRowsSelectionHandler}
							// 	handleRowClick={handleRowClick}
							// 	style={{
							// 		transition: 'height 0.3s ease',
							// 		height: 'calc(100vh - 300px)',
							// 	}}
							// 	responsiveStyles={gridResponsiveStyles}
							// 	localText="No Products Found"
							// />
							filteredProducts?.length ? (
								<div style={isMobileWidth ? { paddingBottom: 100 } : {}}>
									{filteredProducts?.map((product) => {
										return (
											<ProductCard
												//@ts-ignore
												data={product}
												checkBoxSelection={handleSpecificProductSelect}
												view="order"
												increaseQuantity={increaseQuantity}
												decreaseQuantity={decreaseQuantity}
												recommendedQuantity={recommendedQuantity}
												showDetails={showDetails}
											/>
										);
									})}
								</div>
							) : (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									No Products Found
								</div>
							)
						) : (
							<CustomPermission
								icon={<LockIcon />}
								title="We are sorry..."
								paragraph="You do not have permission to view orderbook products. Contact 
					an administrator to get permission."
							/>
						)}
					</Container>

					{deleteProductModal ? (
						<CustomModal
							open={deleteProductModal}
							setOpen={setdeleteProductModal}
							title="Remove Items"
							style={stylingDeleteModal}
							children={
								<ConfirmModal
									content={`Removing ${selectedItemIds?.length} ${
										selectedItemIds?.length > 1 ? 'products' : 'product'
									}  from order`}
									loading={false}
									handleClose={() => setdeleteProductModal(false)}
									handleConfirm={handleConfirm}
								/>
							}
						/>
					) : null}
					{alert?.message !== '' ? <CustomAlert alert={alert} setAlert={setAlert} /> : null}
					<Snackbar
						anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
						open={isErrorVisible}
						autoHideDuration={6000}
						onClose={handleErrorClose}
					>
						<Alert onClose={handleErrorClose} severity="error" elevation={4}>
							{errorMessage}
						</Alert>
					</Snackbar>
					{/* {productDetailsModal ? (
						<CustomModal
							open={productDetailsModal}
							setOpen={setProductDetailsModal}
							style={productDetailsModalStyles}
							title={'Product Details'}
							children={
								<ProductDetails setOpenModal={setProductDetailsModal} data={productDetailsData} />
							}
							header={false}
						/>
					) : null} */}
				</div>
			)}
			{!addProductsComponent && windowDimensions?.width <= 750 ? (
				<StyledBottomBtnContainer>
					<CustomButton
						title={
							btnLoading ? (
								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
							) : (
								'Update'
							)
						}
						handleClick={updateOrder}
						color="primary"
						styles={{
							width: '100%',
							height: '36px',
							// marginRight: '16px',
						}}
						disabled={checkChanges() || disable}
					/>
				</StyledBottomBtnContainer>
			) : null}
			{modals()}
		</>
	);
};

export default EditOrder;
